import React, {useState} from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  TextField,
  MenuItem,
} from '@material-ui/core'

import {Autocomplete} from '@material-ui/lab'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

const FTextField = ({data, onChange = (e, key, value) => {}}) => {
  const [entityOptions, setEntityOptions] = useState([])

  return (
    <>
      <FormControl
        variant="outlined"
        className="ap-textfield"
        style={{width: '100%', marginTop: 16}}
      >
        <Autocomplete
          multiple
          className="ap-textfield ap-autocomplete"
          id="tags-standard"
          options={[]}
          freeSolo
          value={data?.description || []}
          onChange={(e, value) => {
            //setEntityOptions([...value])
            onChange(e, 'description', [...value])
          }}
          renderInput={params => (
            <TextField
              {...params}
              variant="outlined"
              label="List Options"
              placeholder=""
              onKeyPress={event => {
                if (event.key === 'Enter' && event.target.value) {
                  // setEntityOptions([...entityOptions, event.target.value])
                  onChange(event, 'description')
                }
              }}
            />
          )}
        />
      </FormControl>
      <br />
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">Default value</InputLabel>
        <Select
          labelId=""
          id=""
          label="Default value"
          value={data.default_value || []}
          onChange={(e, value) => onChange(e, 'default_value')}
          style={{width: '200px'}}
          multiple={data.type === 'MultipleListField'}
        >
          {data.description &&
            data.description.map(opt => {
              return <MenuItem value={opt}>{`${opt}`}</MenuItem>
            })}
        </Select>
      </FormControl>
    </>
  )
}

export default FTextField
